import VoidInvoiceContainer from "./VoidInvoiceContainer";

export default VoidInvoiceContainer;
